import { DisciplinesService } from "@/api/disciplines";
import type {
  Discipline,
  DisciplineRequestData,
} from "@/api/disciplines/types";
import { buildFormData } from "@/utils/form-data-builder";

export class DisciplinesRepository {
  private static _instance: DisciplinesRepository;

  static get instance(): DisciplinesRepository {
    if (!this._instance) {
      this._instance = new DisciplinesRepository();
    }
    return this._instance;
  }

  private constructor() {}

  async createDiscipline(data: DisciplineRequestData): Promise<Discipline> {
    const { image, ...disciplineData } = data.discipline;

    const formData = buildFormData(
      { discipline: disciplineData },
      image ? { fileField: { key: "discipline[image]", value: image } } : {},
    );

    return DisciplinesService.instance.createDiscipline(formData);
  }

  async updateDiscipline(
    id: string,
    data: DisciplineRequestData,
  ): Promise<Discipline> {
    const { image, ...disciplineData } = data.discipline;

    const formData = buildFormData(
      { discipline: disciplineData },
      image ? { fileField: { key: "discipline[image]", value: image } } : {},
    );

    return DisciplinesService.instance.updateDiscipline(id, formData);
  }
}
